<template>
    <div class="wrapper bg-white">
        <div class="flex align-start justify-between margin-bottom-sm">
            <div class="page-title line-height">草稿箱</div>
            <el-button class="blue-btn" round type="primary" @click="$router.go(-1)"
            >返回
            </el-button
            >
        </div>
        <div class=" flex-sub">
            <div class="flex align-center justify-between margin-bottom-sm list-search">
                <el-input
                    v-model="keyWord"
                    placeholder="请输入单位名称/联系人姓名/联系电话"
                ></el-input>
                <el-button icon="el-icon-search" type="primary" @click="search">搜索</el-button>
            </div>
            <div class="ship-list">
                <el-table
                    v-loading="loading"
                    :data="lists" border
                    header-row-class-name="table-header"
                    style="width: 100%; border-radius: 10px">
                    <el-table-column
                        label="序号"
                        type="index"
                        width="50">
                        <template slot-scope="scope">
                            <div class="table-name">
                                {{ scope.$index + 1 }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="单位名称" prop="company" width="220px">
                        <template slot-scope="scope">
                            <div class="table-name"> {{ scope.row.company }}</div>
                        </template>
                    </el-table-column>
                    <!--            <el-table-column label="法人" prop="name">-->
                    <!--              <template slot-scope="scope">-->
                    <!--                <div class="table-name"> {{scope.row.morgname}}</div>-->
                    <!--              </template>-->
                    <!--            </el-table-column>-->
                    <el-table-column label="联系人" prop="name">
                        <template slot-scope="scope">
                            <div class="table-name"> {{ scope.row.name }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="手机号" prop="phone" width="120px">
                        <template slot-scope="scope">
                            <div class="table-name">
                                {{ scope.row.phone }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="会员等级" prop="rank_name">
                        <template slot-scope="scope">
                            <div class="table-name">
                                {{ scope.row.rank_name }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="缴费状态" prop="status">
                        <template slot-scope="scope">
                            <div class="table-name">
                                {{ scope.row.status === 1 ? '已缴费' : '未缴费' }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="到期时间" prop="end_time" width="110px">
                        <template slot-scope="scope">
                            <div class="table-name">
                                {{ scope.row.end_time | setTime }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="190px">
                        <template slot-scope="scope">
                            <div class="flex justify-center  align-center">
                                <el-link class="table-operate" @click="itemDetail(scope.row.user_id)">编辑</el-link>
                                <el-link class="table-operate active" @click="itemDel(scope.row.user_id)">删除</el-link>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <el-pagination
                :current-page.sync="page"
                :page-size="limit"
                :total="total"
                background
                class="page-all margin-top"
                layout="prev, pager, next, jumper"
                @current-change="userList">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import {endTime, feeList, lockList} from "@/utils/const";
import { memberDel, membersList} from "@/api/branch";
import {zhDate} from "@/utils/utils";
import {baseURL} from "@/config";

export default {
    name: "members",
    data() {
        return {
            baseURL: baseURL,
            levelList: [{
                id: 0,
                name: "全部"
            }],
            feeList: feeList,
            endTime: endTime,
            lockList: lockList,
            level: '',
            fee: '',
            time: '',
            start_time: '',
            end_time: '',
            lock: '',
            keyWord: '',
            lists: [],
            page: 1,
            limit: 15,
            total: 0,
            loading: false,
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        fileData() {
            return {
                mid: this.user.mid,
                sign: this.user.sign,
            }
        }
    },
    created() {
        this.$emit('setIndex', [3, 0], '会员管理')
        this.userList()
    },
    components: {},
    methods: {

        itemDetail(id) {
            this.$router.push(`/branch/members/info/${id}/1`)
        },
        itemDel(id) {
            this.$confirm('此操作将删除该会员, 是否继续?', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.sureDelete(id)
            })
        },
        async sureDelete(id) {
            let _state = await memberDel(id)
            if (_state.status === 200) {
                this.$message.success(_state.msg)
                await this.userList()
            }
        },
        search() {
            this.page = 1
            this.userList()
        },
        // 获取
        async userList() {
            let _list = await membersList(this.page, this.limit,this.start_time,this.end_time,'', this.keyWord, this.level, this.fee, this.time, this.lock,'',1)
            this.lists = _list.data
            this.total = _list.count
        },
    },
    filters: {
        setTime(val) {
            return Number(val) ? zhDate(new Date(val * 1000)) : '--'
        }
    },
    watch: {
        $route: "userList",
    },
}
</script>

<style lang="scss" scoped>
.wrapper {
    .min-height {
        min-height: 930px;
    }

    .classifys {
        margin-bottom: 20px;

        .classify {
            width: 120px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            border: 1px solid #ffb400;
            color: #ffb400;
            border-radius: 0 6px 6px 0;

            &.active {
                background: #ffb400;
                color: #FFFFFF;
                border-radius: 6px 0 0 6px;
            }
        }
    }

    .member-set {
        div {
            width: 130px;
            height: 50px;
            text-align: center;
            line-height: 50px;
            background-color: #f3f7fb;
            border-radius: 10px;
            border: solid 1px #dae0e6;
            font-size: 18px;
            cursor: pointer;

            &:hover {
                background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                linear-gradient(#0a2240, #0a2240);
                background-blend-mode: normal, normal;
                color: #fff;
            }
        }
    }

    .list-search {
        .el-button {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            background: #0a2240;
            border: 0;
            font-size: 16px;
        }
    }

    .table-name {
        font-size: 14px;
        color: #333333;
        text-align: center;

        &.gray {
            color: #999999;
        }
    }

    .table-operate {
        color: #ffa11a;
        margin: 0 5px;

        &.active {
            color: #e4396c;
        }

    }
}
</style>
